<rt-box variant="no-padding vertical no-border no-radius" (click)="toggle()">
  <div
    class="content"
    layout
    layout-align-items-center
    layout-full-height
    padding-left-small-x
    margin-left-small-xxx
  >
    <rt-icon
      [name]="showMore() ? 'expand-less' : 'expand-more'"
      size="small"
      margin-left-small-xx
      margin-right-small-xx
    ></rt-icon>
    <rt-heading variant="subheading">
      {{ (showMore() ? 'app.common.show_less' : 'app.common.show_more') | translate }}
      @if (!showMore()) {
        {{ '(' + remainingPlacementCount() + ')' }}
      }
    </rt-heading>
  </div>
</rt-box>
